import { render, staticRenderFns } from "./Eurofiscalis.vue?vue&type=template&id=f290a928&scoped=true"
import script from "./Eurofiscalis.vue?vue&type=script&lang=ts"
export * from "./Eurofiscalis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f290a928",
  null
  
)

export default component.exports